<template>
  <div class="download">
    <div class="banner-content">
      <img src="../assets/banner-contact.jpg"
           alt="">
      <div class="banner-content-text">
        <div class="w">

          <h3 class="title">
            联系我们
          </h3>
          <h3 class="en">Contact us</h3>
        </div>

      </div>
    </div>
    <div class="w">
      <div class="contact-list-wrap">
        <div class="left-list">

          <div v-for="(item,index) in addressList"
               :key="index"
               class="contact-list ">
            <h2 class="name">{{item.name}}</h2>
            <div class="address">{{item.address}}</div>
            <!-- <div class="address">{{item.phone}}</div> -->
          </div>
        </div>
        <div class="right-list">

          <div v-for="(item,index) in rightList"
               :key="index"
               class="contact-list">
            <h2 class="name">{{item.name}}</h2>
            <div class="address">{{item.address}}</div>
            <div class="address">{{item.phone}}</div>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import Banner from '../components/Banner';
export default {
  components: {
    Banner,
  },
  data() {
    return {
      addressList: [
        {
          name: '北京(汉卓信息技术（上海）有限公司北京分公司)',
          address: '北京市昌平区腾讯众创空间A座221',
          phone: '18810100872',
        },
        {
          name: '上海(汉卓信息技术（上海）有限公司)',
          address: '嘉定区迎园中路622弄2号2085室',
        },
      ],
      rightList: [
        {
          name: '服务专线',
          phone: '18810100872',
        },
        {
          name: '市场商务合作',
          address: '邮箱：info@hzinfor.cn',
          phone: 'HR邮箱：hr@hzinfor.cn',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.banner-content {
  height: 480px;
  background-size: 100%;
  position: relative;
  img {
    height: 100%;
    width: 100%;
  }
  .banner-content-text {
    width: 100%;
    position: absolute;
    top: 80px;
    left: 0;
    z-index: 4;
    .title {
      line-height: 140%;
      font-size: 70px;
      margin-bottom: 40px;
      font-weight: 600;
      color: #191919;
      position: relative;
      padding: 0 80px;
    }
    .en {
      font-weight: bold;
      color: #1766ff;
      padding: 0 80px;
      font-size: 30px;
    }
  }
}
.w {
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 0 80px;
}
.contact-list-wrap {
  padding-left: 80px;
  display: flex;
  justify-content: space-between;
  margin-top: 40px;
  .left-list {
    width: 50%;
  }

  .right-list {
    width: 40%;
  }
}
.contact-list {
  min-height: 126px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 30px;
  .name {
    font-size: 112.5%;
    margin-bottom: 20px;
    color: #000;
    opacity: 0.9;
  }
  .address {
    font-size: 87.5%;
    color: rgba(0, 0, 0, 0.7);
    margin-bottom: 4px;
    line-height: 150%;
  }
}
@media screen and (min-width: 1440px) {
  .w {
    max-width: 1440px;
  }
}
</style>